import { Fileservice } from './../services/fileservice.service';

import { AdbookingService } from './../services/adbooking.service';
import { RegisterComponent } from './../register/register.component';
import { cardDetails } from './../cardDetails';
import { element } from 'protractor';
import { User } from './../user';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CardService } from '../services/cardservice.service';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { AdconfirmationService } from '../service/adconfirmation.service';
import { UserdataService } from '../services/userdata.service';
import { AdDataService } from '../services/addata.service';

// import {cardDetails} from '../cardDetails';

class displayadModelinf {
  adcategory: any;
  choosedAd: any;
  customradio: any;
  basicrate: any;
  widthinput: any;
  heightinput: any;
  adsizeinsqcm: any;
  uploadbtn: any;
  adsize: any;
  adcost: any;
  adContent: any;
  adContentPreview: any;
  gst: any;
  totalCost: any;
  imagename: string;
  adtype: string;
  adpage: string;
  flagupload: any;
  flagdate: any;
  noOfAdDays: any;
  noofdays: any;
  email: any;
  addate: any;
  trxnid: any;
  fileData: File;
  uploadedFilePath: string;
  selectedDate: any;
  orderid: any;

  constructor() {
    this.adcategory = null;
    this.choosedAd = null;
    this.customradio = null;
    this.basicrate = null;
    this.widthinput = null;
    this.heightinput = null;
    this.adsizeinsqcm = null;
    this.uploadbtn = null;
    this.adsize = null;
    this.adcost = null;
    this.adContent = null;
    this.adContentPreview = null;
    this.gst = null;
    this.totalCost = null;
    this.imagename = null;
    this.adtype = null;
    this.adpage = null;
    this.flagupload = null;
    this.flagdate = null;
    this.noOfAdDays = null;
    this.noofdays = null;
    this.email = null;
    this.addate = null;
    this.trxnid = null;
    this.fileData = null;
    this.uploadedFilePath = null;
    this.selectedDate = null;
    this.orderid = null;
  }

}



declare var $: any;
interface paynow {
  flagpaynow: any;
}

@Component({
  selector: 'app-paymentmethod1,app-RegisterComponent',
  templateUrl: './paymentmethod1.component.html',
  styleUrls: ['./paymentmethod1.component.css']
})
export class Paymentmethod1Component implements OnInit {


  displayadModel = {
    adcategory: null,
    choosedAd: null,
    customradio: null,
    basicrate: null,
    widthinput: null,
    heightinput: null,
    adsizeinsqcm: null,
    uploadbtn: null,
    adsize: null,
    adcost: null,
    adContent: null,
    adContentPreview: null,
    gst: null,
    totalCost: null,
    imagename: null,
    adtype: null,
    adpage: null,
    flagupload: null,
    flagdate: null,
    noOfAdDays: null,
    noofdays: null,
    email: null,
    addate: null,
    trxnid: null,
    fileData: null,
    uploadedFilePath: null,
    selectedDate: null,
    touched: null,
    orderid: null,
    guestid: null,
    custid: null
  };

  adDetails = {
    adcategory: '',
    choosedAd: '',
    customradio: '',
    basicrate: '',
    widthinput: '',
    heightinput: '',
    adsizeinsqcm: '',
    uploadbtn: '',
    adContent: '',
    adContentPreview: '',
    adsize: '',
    adcost: '',
    gst: 0,
    totalCost: '',
    imagename: '',
    adtype: '',
    adpage: '',
    noOfAdDays: '',
    noofdays: '',
    email: '',
    addate: '',
    trxnid: '',
    flagupload: true,
    flagdate: true,
    fileData: File = null,
    uploadedFilePath: '',
    selectedDate: [] = '',
    touched: '',
    orderid: ''
  };



  // cardDetails: cardDetails = new cardDetails();
  // user: User = new User();

  selectedDates: any;

  gst: any = 0;
  totalCost: any;
  User: any;
  orderid: any;
  paynowDetails: paynow;
  fileData: File = null;
  fileUploadProgress: string = null;

  cardDetails: any = {
    name: '',
    cardNumber: '',
    expMonth: '',
    expYear: '',
    cvv: '',
    save: true,
    flagpaynow: true,
    custid: '',
    email: ''
  };
  component: any;
  noOfAdDays: string;





  constructor(
    private router: Router,
    private cardService: CardService,
    private fileservice: Fileservice,
    private adbookingService: AdbookingService,
    private userdata: UserdataService,
    private addataservice: AdDataService
  ) {
    // this.displayadModel = JSON.parse(sessionStorage.getItem('Array'));
    this.displayadModel = this.addataservice.getAdData();
    if (!this.displayadModel) {
      this.router.navigate(['/']);
    }
    this.selectedDates = sessionStorage.getItem('selectedDate');
    this.noOfAdDays = sessionStorage.getItem('noOfAdDays');
    this.displayadModel.noofdays = this.noOfAdDays;
    this.displayadModel.addate = this.selectedDates;
    // this.User = JSON.parse(sessionStorage.getItem('User'));
    this.User = this.userdata.getUserData();

    if (this.displayadModel.adcost) {
      this.gst = (parseInt(this.displayadModel.adcost, 10) * 5) / 100;
      this.totalCost =
        parseInt(this.gst, 10) + parseInt(this.displayadModel.adcost, 10);
      if (this.User) {
        if (this.User.email == null) {
          this.cardDetails.email = this.User.emailsignin;
          this.displayadModel.email = this.User.emailsignin;

          // alert(this.displayadModel.addate);

          sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));
        } else {
          this.cardDetails.email = this.User.email;
          this.displayadModel.email = this.User.email;
          this.displayadModel.addate = this.selectedDates;

          // alert(this.displayadModel.addate);
          // alert(this.displayadModel.totalCost);
          sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));
        }
      }
    }
  }

  enablepaynow() {
    this.cardDetails.flagpaynow = false;
    // alert("User :" + this.User.emailsignin);
    // alert(this.cardDetails.email);
  }

  async paynow() {
    this.displayadModel.custid = this.User.custid;
    this.displayadModel.email = this.User.email;
    if (this.User.isGuest) {
      this.saveGuestDetails();
    } else {
      this.saveAdBookingDetails();
      if (this.cardDetails.save === true) {
        this.saveCard();
      }
    }
  }

  saveGuestDetails() {
    this.adbookingService.saveGuestDetails(this.User).subscribe(resp => {
      if (resp.status === 'Success') {
        this.displayadModel.guestid = resp.data.id;
        resp.data.isGuest = true;
        this.userdata.setUserData(resp.data);
        this.saveAdBookingDetails();
        this.saveCard();
      }
    });
  }

  async saveAdBookingDetails() {
    // alert("adbooking Details function");
    this.adbookingService.saveAdBookingDetails(this.displayadModel).subscribe(
      data => {
        console.log(data);
        this.displayadModel.orderid = data.orderid;
        console.log(this.displayadModel.orderid);
        sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));
        this.saveAdDates();
        if (this.displayadModel.fileData) {
          this.fileSave(data.orderid);
        }
        //  sessionStorage.setItem("orderid", this.displayadModel);
        // this.displayadModel = data;
        // sessionStorage.setItem("Array", JSON.stringify(this.displayadModel));
        //  error => console.log(error)
      },
      error => console.log(error)
    );
  }

  fileSave(id) {
    console.log('file saved');
    const file = this.displayadModel.fileData;
    this.adbookingService.savefile(file, id).subscribe(data => {
      console.log(data);
    });
  }

  saveAdDates() {
    this.adbookingService.saveAdDates(this.displayadModel).subscribe(
      data => {
        console.log(data);

        this.saveAdPayments();
        // this.displayadModel = data;
        // sessionStorage.setItem("Array", JSON.stringify(this.displayadModel));
        //  error => console.log(error)
      },
      error => console.log(error)
    );
  }

  saveAdPayments() {
    this.adbookingService.saveAdPayments(this.displayadModel).subscribe(
      data => {
        console.log(data);
        // sessionStorage.clear();
        this.router.navigate(['/adconfirmation1']);
        // this.displayadModel = data;
        // sessionStorage.setItem("Array", JSON.stringify(this.displayadModel));
        //  error => console.log(error)
      },
      error => console.log(error)
    );
  }

  saveFiles() {
    const formData = new FormData();
    console.log(this.displayadModel.fileData);

    formData.append('myfile', this.displayadModel.fileData);
    // alert("From saveFiles:" + this.displayadModel.fileData);
    // alert("From saveFiles name:" + this.displayadModel.imagename);
    this.displayadModel.flagdate = false;
    this.fileservice.saveFile(formData).subscribe(
      data => {
        console.log(data);
      },
      error => console.log(error)
    );
  }
  saveCard() {
    this.User = this.userdata.getUserData();
    if (this.User.isGuest) {
      this.cardDetails.guestid = this.User.id;
      this.cardDetails.email = this.User.email;
    }
    this.cardService.saveCardDetails(this.cardDetails).subscribe(
      data => {
        console.log(data);
        //  error => console.log(error)
      },
      error => console.log(error)
    );

    // this.gotoList();
  }
  gotoList() {
    this.router.navigate(['/adconfirmation1']);
  }

  ngOnInit() {

    $('#myButton1').click(function() {
      $('#myButton1').hide();
      $('.load').addClass('loading');
        setTimeout(function() {
        $('.load').removeClass('loading');
        $('#myButton1').show();

      }, 3000);

    });

    console.log(this.displayadModel.choosedAd);
    this.component = this.displayadModel.choosedAd;



    $('#test_form').on('keyup', function(e) {
      let val = $(this).val();
      let newval = '';
      val = val.replace(/\s/g, '');
      for (let i = 0; i < val.length; i++) {
        if (i % 4 === 0 && i > 0) { newval = newval.concat(' '); }
        newval = newval.concat(val[i]);
      }
      $(this).val(newval);
    });

  }
}
